import React, { useState } from 'react';

import { Typography, Input, Row, Button, Alert } from 'antd';

import { LoginGeneratedProps } from './Login.props';
import { Container, FormContainer, StyledAlert } from './Login.style';

const LoginView = (props: LoginGeneratedProps): JSX.Element => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const authenticate = () => props.onLogin(email, password);

  return (
    <Container>
      <FormContainer size={8} direction="vertical">
        <Row>
          <Typography>Innovation Junkie Survey Admin</Typography>
        </Row>

        {!!props.errorMessage && (
          <Row>
            <StyledAlert message={props.errorMessage} type="error" showIcon />
          </Row>
        )}

        <Row gutter={[0, 8]} justify="end">
          <Input
            placeholder="Email"
            disabled={props.loading}
            name="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <Input
            placeholder="Password"
            type="password"
            disabled={props.loading}
            name="password"
            onChange={e => setPassword(e.target.value)}
            onPressEnter={authenticate}
          />
          <Button
            loading={props.loading}
            type="primary"
            onClick={authenticate}
          >
            Login
          </Button>
        </Row>
      </FormContainer>
    </Container>
  );
};

export default LoginView;
